import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type Props = {
	children: ReactNode;
	testId?: string;
};

const ActiveItem = ({ children, testId }: Props) => (
	<ActiveItemWrapper data-testid={testId}>{children}</ActiveItemWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ActiveItemWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
	borderRadius: token('border.radius', '3px'),

	backgroundColor: token('color.background.neutral'),
});

export default ActiveItem;
